import {
  Input,
  InputNumber,
  Checkbox,
  CheckboxGroup,
  Form,
  FormItem,
  Select,
  Option,
  Button,
  Table,
  TableColumn,
  Tabs,
  TabPane,
  Tag,
  Pagination,
  Dialog,
  Descriptions,
  DescriptionsItem,
  Message,
  Radio,
  RadioGroup,
  Row,
  Switch,
  Col,
  Progress,
  Link,
  Image,
  Breadcrumb,
  BreadcrumbItem,
  Popover,
  Card,
  MessageBox,
  Tree,
  Tooltip,
  Empty,
  Drawer,
  Divider,
  DatePicker,
  Cascader,
  Transfer,
  Upload,
  Loading,
  Slider,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Scrollbar
} from "element-ui";
import ImageViewer from "element-ui/packages/image/src/image-viewer";

Input.props.clearable = {
  type: Boolean,
  default: true
};
InputNumber.props.clearable = {
  type: Boolean,
  default: true
};
Select.props.clearable = {
  type: Boolean,
  default: true
};
Dialog.props.closeOnClickModal = {
  type: Boolean,
  default: false
};
export default {
  install(Vue, options) {
    const messageOption = {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      title: "提示",
      type: "warning"
    };
    /* NOSONAR */ Vue.prototype.$msgbox = MessageBox;
    /* NOSONAR */ Vue.prototype.$alert = (message, options) =>
      MessageBox({
        ...messageOption,
        customClass: "alertMessageBox",
        showClose: false,
        message,
        ...options
      });
    /* NOSONAR */ Vue.prototype.$confirm = (message, options) =>
      MessageBox({
        ...messageOption,
        customClass: "confirmMessageBox",
        showClose: false,
        showCancelButton: true,
        message,
        ...options
      });
    Vue.component("ElImageViewer", ImageViewer);
    Vue.use(Breadcrumb);
    Vue.use(BreadcrumbItem);
    Vue.use(Popover);
    Vue.use(Card);
    Vue.use(Checkbox);
    Vue.use(CheckboxGroup);
    Vue.use(Dialog);
    Vue.use(Pagination);
    Vue.use(Form);
    Vue.use(FormItem);
    Vue.use(Select);
    Vue.use(Option);
    Vue.use(Button);
    Vue.use(Input);
    Vue.use(InputNumber);
    Vue.use(Switch);
    Vue.use(Table);
    Vue.use(TabPane);
    Vue.use(Tabs);
    Vue.use(TableColumn);
    Vue.use(Tag);
    Vue.use(Descriptions);
    Vue.use(DescriptionsItem);
    Vue.use(Radio);
    Vue.use(RadioGroup);
    Vue.use(Row);
    Vue.use(Col);
    Vue.use(Progress);
    Vue.use(Link);
    Vue.use(Image), Vue.use(Tree);
    Vue.use(Empty);
    // Vue.use(MessageBox);
    Vue.use(Tooltip);
    Vue.use(Drawer);
    Vue.use(Divider);
    Vue.use(DatePicker);
    Vue.use(Cascader);
    Vue.use(Transfer);
    Vue.use(Upload);
    Vue.use(Loading);
    Vue.use(Slider);
    Vue.use(Dropdown);
    Vue.use(DropdownMenu);
    Vue.use(DropdownItem);
    Vue.use(Scrollbar);

    Vue.prototype.$message = Message;
  }
};
